import { format } from 'date-fns';
import BaseApi from './baseApi';

export default class IntegrationsApi extends BaseApi {
  static uploadTaFile = (file, providerId, companyId) => {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('providerId', providerId);
    formData.append('companyId', companyId);

    const config = {
      headers: this.getAuthHeaders({ contentType: 'multipart/form-data' }),
    };

    return this.axiosInstance.post(`${this.API}/integrations/ta/upload/`, formData, config);
  };

  static getIntegrationsResults = (params, filters = {}) => {
    const { limit, page = 1 } = params;

    const getFiltersForApi = () => {
      const apiFilters = {};
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          if (key === 'dates') {
            // Convert the dates to ISO 8601 format (e.g. 2000-12-31)
            if (value?.from) {
              apiFilters.startDate = format(value.from, 'yyyy-MM-dd');
            }

            if (value?.to) {
              apiFilters.endDate = format(value.to, 'yyyy-MM-dd');
            }
          } else {
            apiFilters[key] = value;
          }
        }
      });
      return apiFilters;
    };

    const config = {
      method: 'post',
      headers: this.getAuthHeaders(),
      params: { limit, page },
    };

    return this.axiosInstance.post(
      `${this.API}/integrations/results`,
      JSON.stringify(getFiltersForApi()),
      config,
    );
  };

  static getIntegrationsErrors = (integrationResultId, companyId) => {
    const config = {
      method: 'get',
      headers: this.getAuthHeaders(),
    };

    if (integrationResultId) {
      return this.axiosInstance.get(
        `${this.API}/integrations/errors?integrationResultId=` + integrationResultId,
        config,
      );
    } else if (companyId) {
      return this.axiosInstance.get(
        `${this.API}/integrations/errors?companyId=` + companyId,
        config,
      );
    } else {
      return this.axiosInstance.get(`${this.API}/integrations/errors`, config);
    }
  };

  static triggerIntegrationAction = (integrationActionId) => {
    const config = {
      method: 'get',
      headers: this.getAuthHeaders(),
    };

    if (integrationActionId) {
      return this.axiosInstance.get(
        `${this.API}/integrations/actions?integrationActionId=` + integrationActionId,
        config,
      );
    }
  };

  static triggerAttendanceIntegrationActionByCompanyId = (companyId) => {
    const config = {
      method: 'get',
      headers: this.getAuthHeaders(),
    };

    if (companyId) {
      return this.axiosInstance.get(
        `${this.API}/integrations/actions?companyId=` + companyId,
        config,
      );
    }
  };

  static setIntegrationErrorState = (errorId, state) => {
    let body = {
      errorId: String(errorId),
      state: state,
    };

    const config = {
      headers: this.getAuthHeaders(),
    };

    return this.axiosInstance.post(`${this.API}/integrations/errors`, JSON.stringify(body), config);
  };

  static downloadIntegrationFile = (integrationActionResultId) => {
    const config = {
      method: 'get',
      headers: this.getAuthHeaders(),
    };

    if (integrationActionResultId) {
      return this.axiosInstance.get(
        `${this.API}/integrations/actions/download?integrationActionResultId=` +
          integrationActionResultId,
        config,
      );
    }
  };
}
